<template>
  <BreadCrumb v-if="showgrid" page="Beranda > Pendaftaran > Data Penerimaan > Lihat Data Diterima "></BreadCrumb>
  <div class="container-fluid content-area" v-if="showgrid">
    <div class="row">
      <div class="col-md-12">
        <h3 class="judul-seksi-sga">Data Diterima - SK dan Status Pembayaran Uang Sekolah Tahun Ajaran {{this.$store.getters.getTahunAJaran}}</h3>
      </div>
    </div>
    <div class="" style="padding-top: 20px;">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <Button
                type="button"
                icon="pi pi-file-excel"
                label="Export to Excel"
                severity="success"
                @click="exportToExcel"
            />
            <DataTable class="table table-border-bottom-0"
                       v-model:filters="filters"
                       :value="dataKeputusanDiterima"
                       ref="dt"
                       tableStyle="min-width: 50rem"
                       paginator :rows="10"
                       :rowsPerPageOptions="[5, 10, 20, 50]"
                       :first="0"
                       :loading="loading"
            >
              <template #header>
                <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                    </span>
                </div>
              </template>
              <template #empty> Data tidak ada. </template>
              <template #loading> Mengambil data. Mohon tunggu. </template>
              <Column field="no_formulir" header="No formulir" sortable></Column>
              <Column field="nama_anak" header="Nama Anak" filterMatchMode="startsWith" sortable>
              </Column>
              <Column field="ortu" header="Nama Orang Tua" sortable style="width: 25%"></Column>
              <Column field="jadwal_wawancara" header="Status SK" sortable></Column>
              <Column field="statuskeputusan" header="Keputusan" sortable></Column>
              <Column field="tanggal_wawancara" header="Status Tagihan" sortable style="width: 25%"></Column>
              <Column field="diskontipe" header="Status Diskon" sortable></Column>
              <Column field="statuspelunasan" header="Status Pelunasan" sortable></Column>
              <Column field="statuskwitansi" header="Status Kwitansi" sortable></Column>
              <Column header="SK">
                <template #body="slotProps">
                  <a href="#" @click="toggleGrid(slotProps.data)" class="fa-solid fa-eye"></a>
                </template>
              </Column>
              <Column header="Pelunasan">
                <template #body="slotProps">
                  <a href="#" @click="togglePelunasan(slotProps.data)" class="fa-solid fa-eye"></a>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!showgrid">
    <PageViewPSBditerima
        :data="selectedFormulir" v-if="showsk"
        @change-view="toogleviewshowgrid">
    </PageViewPSBditerima>
    <PageViewPSBditerimaPelunasan
        :data="selectedFormulir" v-if="showpelunasan"
        @change-view="toogleviewshowpelunasan">
      ></PageViewPSBditerimaPelunasan>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import {FilterMatchMode} from "@primevue/core/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import DashboardServices from "@/services/dashboard.services";
import PageViewPSBditerima from "@/components/viewadmin/penerimaan/PageViewPSBditerima";
import Button from "primevue/button";
import PageViewPSBditerimaPelunasan from "@/components/viewadmin/penerimaan/PageViewPSBditerimaPelunasan";
import * as XLSX from "xlsx";
export default {
  name: "ViewDataPSBditerima",
  components: {PageViewPSBditerimaPelunasan, PageViewPSBditerima, BreadCrumb,DataTable,Column,InputText,Button},
  data:()=>({
    loading: false,
    lazyParams: {},
    showgrid: true,
    showpelunasan: false,
    showsk: false,
    response:'',
    message:'',
    success: false,
    dataKeputusanDiterima:[],
    selectedFormulir:[],
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      'no_formulir': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'nama_anak': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'nama_ortu': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'jadwal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'tanggal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
    },
  }),
  methods:{
    // Excel Export Logic
    exportToExcel() {
      // Data dari API
      const dataToExport = this.dataKeputusanDiterima;

      if (!dataToExport || dataToExport.length === 0) {
        alert('Tidak ada data untuk diexport.');
        return;
      }

      // Mapping data sesuai kolom DataTable
      const excelData = dataToExport.map((item, index) => ({
        'No': index + 1,
        'No Formulir': item.no_formulir,
        'Nama Anak': item.nama_anak,
        'Nama Orang Tua': item.ortu,
        'Status SK': item.jadwal_wawancara,
        'Keputusan': item.statuskeputusan,
        'Status Tagihan': item.tanggal_wawancara,
        'Status Diskon': item.diskontipe,
        'Status Pelunasan': item.statuspelunasan,
        'Status Kwitansi': item.statuskwitansi
      }));

      // Buat worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Lebar kolom Excel
      worksheet['!cols'] = [
        { wch: 6 },   // No
        { wch: 20 },  // No Formulir
        { wch: 30 },  // Nama Anak
        { wch: 30 },  // Nama Orang Tua
        { wch: 20 },  // Status SK
        { wch: 20 },  // Keputusan
        { wch: 20 },  // Status Tagihan
        { wch: 20 },  // Status Diskon
        { wch: 20 },  // Status Pelunasan
        { wch: 20 }   // Status Kwitansi
      ];

      // Buat workbook
      const workbook = XLSX.utils.book_new();

      // Tambahkan worksheet
      XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          'Penerimaan PSB'
      );

      // Download Excel
      XLSX.writeFile(
          workbook,
          'data_penerimaan_psb.xlsx'
      );
    },
    toogleviewshowgrid(){
      this.showgrid = true;
    },
    toogleviewshowpelunasan(){
      this.showpelunasan = true;
      this.showgrid = true;
    },
    toggleGrid(data){
      this.showgrid = false;
      this.showsk = true;
      this.showpelunasan = false;
      this.selectedFormulir = data;
    },
    togglePelunasan(data){
      this.showgrid = false;
      this.showsk = false;
      this.showpelunasan = true;
      this.selectedFormulir = data;
    },
    getDataDiterima(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataPSBditerima';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataKeputusanDiterima = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },
  mounted() {
    this.getDataDiterima();
  }
}
</script>

<style scoped>

</style>